import React from 'react';
import { DESTINATION_TYPES } from '../../constants/destinationTypes';
import { NodeLogoWithText } from '../../../../media/components/node-logo-with-text/NodeLogoWithText';
import { OptionsType } from '../../../../dropdown/components/dropdown/Dropdown';

export interface DestinationFilterCustomOptionProps {
  option: OptionsType;
}
export function DestinationFilterCustomOption({ option }: DestinationFilterCustomOptionProps) {
  const warehouseLogoInfo = {
    logoURL: option.img,
    darkModeLogoURL: option.darkModeImg,
    primaryColor: DESTINATION_TYPES[option.type].primaryColor,
    darkModePrimaryColor: DESTINATION_TYPES[option.type].darkModePrimaryColor
  };
  return (
    <NodeLogoWithText
      option={warehouseLogoInfo}
      name={option.name}
      size={2}
      logoClassName='mr-3'
      roundedBorders
      zIndex={1305}
    />
  );
}
